import { QuantitySelectorComponent } from '@theme/component-quantity-selector';

/**
 * A custom element that allows the user to select a quantity in the cart.
 * Extends QuantitySelectorComponent but uses absolute max limits instead of effective max.
 * Semantics: "What should the total quantity BE in the cart" vs "How many to ADD to cart"
 *
 * @extends {QuantitySelectorComponent}
 */
class CartQuantitySelectorComponent extends QuantitySelectorComponent {
  /**
   * Gets the effective maximum value for cart quantity selector
   * Cart page: uses absolute max (how much can be in cart total)
   * @returns {number | null} The effective max, or null if no max
   */
  getEffectiveMax() {
    const { max } = this.getCurrentValues();
    return max; // Cart uses absolute max, not max minus cart quantity
  }

  /**
   * Updates button states based on current value and limits.
   *
   * If the element carries `data-locked="true"` (set by the Liquid quantity
   * selector when `can_update_quantity` is false — used for subscription
   * bundles whose discount is tied to a fixed quantity), keep both buttons
   * AND the number input disabled. The cart morph re-runs this method after
   * every cart interaction, so without this guard the lock would be reset
   * to "always editable" the moment any other line is touched.
   */
  updateButtonStates() {
    const { minusButton, plusButton, quantityInput } = this.refs;

    if (this.dataset.locked === 'true') {
      if (minusButton) minusButton.disabled = true;
      if (plusButton) plusButton.disabled = true;
      if (quantityInput) quantityInput.disabled = true;
      return;
    }

    const { min, value } = this.getCurrentValues();
    const effectiveMax = this.getEffectiveMax();

    // Cart buttons are always dynamically managed
    minusButton.disabled = value <= min;
    plusButton.disabled = effectiveMax !== null && value >= effectiveMax;
  }
}

if (!customElements.get('cart-quantity-selector-component')) {
  customElements.define('cart-quantity-selector-component', CartQuantitySelectorComponent);
}
